var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarrier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0797 6.78996L11.5197 0.699951L0.969727 6.78996V18.98L11.5197 25.07L22.0797 18.98V6.78996Z",
    fill: "#4F80DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0699 22.04H21.0599C21.2587 22.04 21.4199 21.8789 21.4199 21.68V11.96C21.4199 11.7612 21.2587 11.6 21.0599 11.6H17.0699C16.8711 11.6 16.7099 11.7612 16.7099 11.96V21.68C16.7099 21.8789 16.8711 22.04 17.0699 22.04Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2195 21.5601H19.9795C20.1397 21.5601 20.2695 21.4302 20.2695 21.2701V12.3601C20.2695 12.1999 20.1397 12.0701 19.9795 12.0701H17.2195C17.0594 12.0701 16.9295 12.1999 16.9295 12.3601V21.2701C16.9295 21.4302 17.0594 21.5601 17.2195 21.5601Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.431523 5.9798L0.427706 5.98904C0.191493 6.56072 0.463434 7.21566 1.03511 7.45187L17.8373 14.3944C18.409 14.6306 19.0639 14.3587 19.3001 13.787L19.304 13.7777C19.5402 13.2061 19.2682 12.5511 18.6965 12.3149L1.89434 5.37239C1.32266 5.13618 0.667736 5.40812 0.431523 5.9798Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3893 6.52002L3.5293 8.51003L6.7193 9.82002L7.6693 7.93002L4.3893 6.52002Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0299 9.35986L10.1699 11.3599L13.3599 12.6699L14.3099 10.7699L11.0299 9.35986Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrier);
export default __webpack_public_path__ + "static/media/barrier.047a90d4.svg";
export { ForwardRef as ReactComponent };